<template>
    <div class="col-12">
        <nav class="nav text-uppercase">
            <router-link
                class="nav-link"
                v-for="(item, index) in nav"
                :key="index + 0"
                :to="{ name: item.routeName}"
                :class="{ 'active' : activeRouteName === item.routeName}"
            >
                {{ getTitle(item) }}
            </router-link>
        </nav>
        <div class="my-3"></div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    nav: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeRouteName () {
      return this.$route.name
    }
  },
  methods: {
    getTitle (navItem) {
      let title = this.$t(navItem.title)
      if (navItem.hasOwnProperty('suffix')) {
        title = title + ' ' + navItem.suffix
      }
      return title
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/TopModalNavigation.vue